import React, { useEffect } from 'react';
import { AdaptiveModal } from './AdaptiveModal';
import { HINT_GOT_IT } from '../../utils/hintCopy';
import './HintPopup.css';

/**
 * Craft-help popup: title, plain body, one outlined Got it. Bottom sheet on phone.
 */
export default function HintPopup({
  isOpen,
  onClose,
  title,
  content,
  actionLabel = HINT_GOT_IT,
}) {
  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (event) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const footer = (
    <button type="button" className="hint-popup__action" onClick={onClose}>
      {actionLabel || HINT_GOT_IT}
    </button>
  );

  return (
    <AdaptiveModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      footer={footer}
    >
      <div className="hint-popup__body">
        <p>{content}</p>
      </div>
    </AdaptiveModal>
  );
}
